import classNames from "classnames";
import { ReactToMarionetteView } from "extensions/marionette";

import "./loginWrapper.scss";

function SharedLoginWrapper(props) {
    return (
        <div className="pz-login login-page">
            <div className="row">
                <div className="logo col-md-4 col-md-offset-4">Pazien</div>
            </div>
            <div className="row">
                <div className={classNames("merchant-login", { "col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4": !props.stretch }, { "col-sm-12 col-md-6 col-md-offset-3": props.stretch })}>
                    <div className={classNames({ row: props.stretch })}>
                        <div className={classNames({ "col-md-10 col-md-offset-1": !props.stretch }, "login-area")}>
                            {props.content}
                        </div>
                    </div>
                    <div className={classNames({ "debug-info": props.api })}>
                        {props.api ? `API: ${props.api}` : ""}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 col-md-offset-4 spacer text-center copyright"><small>{props.copyright}</small>
                </div>
            </div>
        </div>
    );
}

SharedLoginWrapper.defaultProps = {
    api: "",
    stretch: false
};

export const LoginWrapper = ReactToMarionetteView.extend({
    component() {
        return <SharedLoginWrapper stretch={this.getOption("stretch")} content={this.getOption("content")}/>;
    },
    dumb: true
});
